import React, { useState } from 'react';
import { Icon } from '../common/Icons';

export default function SettingsModal({ onClose, onEmptyTrash }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');
  const [defaultView, setDefaultView] = useState(() => localStorage.getItem('view_mode') || 'grid');

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  const handleViewChange = (newView) => {
    setDefaultView(newView);
    localStorage.setItem('view_mode', newView);
  };

  return (
    <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="modal-sheet-box settings-modal-box" role="dialog" aria-modal="true">
        <div className="sheet-drag-handle" />

        <div className="modal-header">
          <div className="modal-header-title-group">
            <div className="modal-header-icon info">
              <Icon name="settings" size={18} />
            </div>
            <h2 className="modal-title">Settings & Preferences</h2>
          </div>
          <button type="button" className="btn-icon" onClick={onClose} aria-label="Close">
            <Icon name="close" size={18} />
          </button>
        </div>

        <div className="modal-body settings-modal-body">
          {/* Appearance Section */}
          <div className="settings-section">
            <h3 className="settings-section-title">
              <Icon name="sun" size={16} />
              <span>Appearance</span>
            </h3>
            <p className="settings-section-desc">Choose how Memora looks on your screen</p>

            <div className="settings-option-grid">
              <button
                type="button"
                className={`theme-choice-card ${theme === 'dark' ? 'active' : ''}`}
                onClick={() => handleThemeChange('dark')}
              >
                <div className="theme-preview dark-preview">
                  <div className="preview-topbar" />
                  <div className="preview-body">
                    <div className="preview-card" />
                    <div className="preview-card" />
                  </div>
                </div>
                <div className="theme-choice-footer">
                  <div className="theme-choice-label">
                    <Icon name="moon" size={15} />
                    <span>Dark Obsidian</span>
                  </div>
                  {theme === 'dark' ? (
                    <span className="theme-active-check">
                      <Icon name="check" size={12} />
                    </span>
                  ) : (
                    <span className="theme-radio-dot" />
                  )}
                </div>
              </button>

              <button
                type="button"
                className={`theme-choice-card ${theme === 'light' ? 'active' : ''}`}
                onClick={() => handleThemeChange('light')}
              >
                <div className="theme-preview light-preview">
                  <div className="preview-topbar" />
                  <div className="preview-body">
                    <div className="preview-card" />
                    <div className="preview-card" />
                  </div>
                </div>
                <div className="theme-choice-footer">
                  <div className="theme-choice-label">
                    <Icon name="sun" size={15} />
                    <span>Light Slate</span>
                  </div>
                  {theme === 'light' ? (
                    <span className="theme-active-check">
                      <Icon name="check" size={12} />
                    </span>
                  ) : (
                    <span className="theme-radio-dot" />
                  )}
                </div>
              </button>
            </div>
          </div>

          {/* Notes Layout Default */}
          <div className="settings-section">
            <h3 className="settings-section-title">
              <Icon name="grid" size={16} />
              <span>Default Note Layout</span>
            </h3>
            <p className="settings-section-desc">Select your preferred viewing format for notes</p>

            <div className="segmented-control">
              <button
                type="button"
                className={`segment-btn ${defaultView === 'grid' ? 'active' : ''}`}
                onClick={() => handleViewChange('grid')}
              >
                <Icon name="grid" size={15} />
                <span>Card Grid View</span>
              </button>
              <button
                type="button"
                className={`segment-btn ${defaultView === 'list' ? 'active' : ''}`}
                onClick={() => handleViewChange('list')}
              >
                <Icon name="list" size={15} />
                <span>Compact List View</span>
              </button>
            </div>
          </div>

          {/* Organization & Folders */}
          <div className="settings-section">
            <h3 className="settings-section-title">
              <Icon name="folder" size={16} />
              <span>Folder Management</span>
            </h3>
            <p className="settings-section-desc">
              Notes created without a specified folder are automatically saved into your default <strong>"My Folder"</strong> folder.
            </p>
          </div>

          {/* Trash Policy */}
          <div className="settings-section">
            <h3 className="settings-section-title">
              <Icon name="trash" size={16} />
              <span>Trash & Data Retention</span>
            </h3>
            <p className="settings-section-desc">
              Deleted notes are safely stored in the Trash for <strong>7 days</strong> before permanent deletion. You can restore them anytime during this period.
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-primary-custom" onClick={onClose} style={{ marginLeft: 'auto' }}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

